import Axios from "axios";
import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import AppConfig from "../../../../../config/AppConfig";
class ChartSebaranAPTBerdasarkanJenis extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: [],
      unggul: [],
      a: [],
      baik_sekali: [],
      b: [],
      baik: [],
      c: [],
      tidak_terakreditasi: [],
      loading: false,
    };
  }

  options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback: function(label, index, labels) {
              // when the floored value is the same as the value we have a whole number
              if (Math.floor(label) === label) {
                return label;
              }
            },
          },
        },
      ],
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
      },
    },
  };
  getData() {
    this.setState({
      loading: true,
    });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    if (userdata) {
      session =
        "?tipe_lembaga=" +
        this.props.tipe_lembaga +
        "&id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let i = 0;
    let labels = [];
    let unggul = [];
    let a = [];
    let baik_sekali = [];
    let b = [];
    let baik = [];
    let c = [];
    let tidak_terakreditasi = [];
    Axios.get(AppConfig.DetailDashboard + "sebaranakreditasi" + session)
      .then((res) => {
        for (var key in res.data.result.data_vokasi) {
          labels[i] = key;
          unggul[i] = res.data.result.data_vokasi[key].unggul;
          a[i] = res.data.result.data_vokasi[key].a;
          baik_sekali[i] = res.data.result.data_vokasi[key].baik_sekali;
          b[i] = res.data.result.data_vokasi[key].b;
          baik[i] = res.data.result.data_vokasi[key].baik;
          c[i] = res.data.result.data_vokasi[key].c;
          tidak_terakreditasi[i] =
            res.data.result.data_vokasi[key].tidak_terakreditasi;
          i = i + 1;
        }

        this.setState({
          label: labels,
          unggul: unggul,
          a: a,
          baik_sekali: baik_sekali,
          b: b,
          baik: baik,
          c: c,
          tidak_terakreditasi: tidak_terakreditasi,
          loading: false,
        });
      })
      .catch((err) => {
        alert("not found");
      });
  }
  async componentDidMount() {
    this.getData();
  }
  async componentDidUpdate() {
    if (this.props.status === true) {
      this.getData();
      this.props.parentCallback(false);
    }
  }
  render() {
    let datas = {
      labels: this.state.label,
      datasets: [
        {
          label: "Unggul",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#275384",
          borderColor: "#275384",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#275384",
          pointBackgroundColor: "#275384",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#275384",
          pointHoverBorderColor: "#275384",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.unggul,
        },
        {
          label: "A",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#ED7D39",
          borderColor: "#ED7D39",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#ED7D39",
          pointBackgroundColor: "#ED7D39",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#ED7D39",
          pointHoverBorderColor: "#ED7D39",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.a,
        },
        {
          label: "Baik Sekali",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#F8C145",
          borderColor: "#F8C145",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#F8C145",
          pointBackgroundColor: "#F8C145",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#F8C145",
          pointHoverBorderColor: "#F8C145",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.baik_sekali,
        },
        {
          label: "B",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#5B9BD5",
          borderColor: "#5B9BD5",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#5B9BD5",
          pointBackgroundColor: "#5B9BD5",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#5B9BD5",
          pointHoverBorderColor: "#5B9BD5",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.b,
        },
        {
          label: "Baik",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#79B4B7",
          borderColor: "#79B4B7",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#79B4B7",
          pointBackgroundColor: "#79B4B7",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#79B4B7",
          pointHoverBorderColor: "#79B4B7",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.baik,
        },
        {
          label: "C",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#DCE2E2",
          borderColor: "#DCE2E2",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#DCE2E2",
          pointBackgroundColor: "#DCE2E2",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#DCE2E2",
          pointHoverBorderColor: "#DCE2E2",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.c,
        },
        {
          label: "Tidak Terakreditasi",
          fill: false,
          lineTension: 0.1,
          backgroundColor: "#A8E7E9",
          borderColor: "#A8E7E9",
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: "miter",
          pointBorderColor: "#A8E7E9",
          pointBackgroundColor: "#A8E7E9",
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: "#A8E7E9",
          pointHoverBorderColor: "#A8E7E9",
          pointHoverBorderWidth: 2,
          pointRadius: 1,
          pointHitRadius: 10,
          data: this.state.tidak_terakreditasi,
        },
      ],
    };
    return (
      <>
        {this.state.loading === true ? (
          <span className="ml-3 spinner spinner-black"></span>
        ) : (
          <Bar data={datas} options={this.options} />
        )}
      </>
    );
  }
}
export default ChartSebaranAPTBerdasarkanJenis;
